import { FC, useMemo } from 'react'

import { useSimpleGuard } from 'helpers/loadableHelpers'
import { rewardsSummaryGuard } from 'components/features/rewards/rewardsPane/guards/rewardsSummaryGuard'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { minRedemptionAmountSelector, rewardSummarySelector } from 'selectors/bountySelectors'
import { SummaryActions } from 'components/features/rewards/rewardPageSummary/SummaryActions/SummaryActions'
import { RewardSummaryDataState } from 'components/features/rewards/rewardPage/store'
import { SummaryContent } from 'components/features/rewards/rewardPageSummary/SummaryContent/SummaryContent'
import { LeftToInvest } from 'components/features/rewards/rewardPageSummary/LeftToInvest/LeftToInvest'

export const RewardsSummary: FC = (props) => {
  const isSummaryLoaded = useSimpleGuard(rewardsSummaryGuard, props, 'RewardsPageRewardsSummary', { fixPropsCheck: true })

  const summary = useStoreSelector(rewardSummarySelector)
  const minRedemptionAmount = useStoreSelector(minRedemptionAmountSelector)

  return useMemo(() => {
    if (!isSummaryLoaded || !summary || minRedemptionAmount === null) {
      return (
        <LoadingOverlay />
      )
    }

    return (
      <RewardsSummaryInner
        summary={ summary }
        minRedemptionAmount={ minRedemptionAmount }
      />
    )
  }, [isSummaryLoaded, summary, minRedemptionAmount])

}
type RewardsSummaryInnerProps = {
  summary: RewardSummaryDataState
  minRedemptionAmount: number
}
const RewardsSummaryInner: FC<RewardsSummaryInnerProps> = (props) => {
  const { summary, minRedemptionAmount } = props
  const { usdBalance, cryptoBalance } = summary

  const contentChild = useMemo(() => {
    if (usdBalance >= minRedemptionAmount || cryptoBalance > 0) {
      return (
        <SummaryContent />
      )
    }

    return (
      <LeftToInvest />
    )
  }, [cryptoBalance, minRedemptionAmount, usdBalance])


  return (
    <>
      { contentChild }
      <SummaryActions />
    </>
  )
}
